<template>
  <div
    class="container"
    @click="register"
    >
    <small>
      {{ $l.hasAccount }}
    </small>

    <div class="button">
      {{ $l.registerHere }}
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  methods: {
    register: function () {
      this.$router.push({ name: 'register' })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.button {
  box-sizing: border-box;
  padding-bottom: 3px;
  &:hover {
    border-bottom: 1px solid white;
    cursor: pointer;
  }
}
</style>
